// extracted by mini-css-extract-plugin
export default {"container":"WhatsAppFloat_container__eVt3d","icon":"WhatsAppFloat_icon__GvQiI","label":"WhatsAppFloat_label__x2b5e"};